import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.869 19.999a1 1 0 00.865 1.501h18.532a1 1 0 00.865-1.501L12.865 3.995a1 1 0 00-1.73 0L1.869 19.999zm3.468-.499a.5.5 0 01-.433-.75l6.663-11.512a.5.5 0 01.866 0l6.663 11.512a.5.5 0 01-.433.75H5.337zm5.663-3h2v2h-2v-2zm0-5a1 1 0 112 0v2a1 1 0 11-2 0v-2z" fill="#9E5F00" /></svg>;